module.exports = __webpack_public_path__ + "static/media/Group13.3fd9d031.png";